import React from 'react';
import Info from './containers/info';
import ProjectsSection from './containers/projects-section';
import './App.scss';

const App = () => (
  <div className="App">
    <Info />
    <ProjectsSection />
  </div>
);

export default App;
